'use strict';

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _date_utils = require('./date_utils');

var _constants = require('../../shared/constants');

var _Time = require('@wix/wixrest-utils/dist/Time');

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Day = function (_React$Component) {
    _inherits(Day, _React$Component);

    function Day() {
        var _temp, _this, _ret;

        _classCallCheck(this, Day);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            markerPos: {}
        }, _this.handleClick = function (event) {
            if (!_this.isDisabled() && _this.props.onClick && _this._isApplicable()) {
                _this.props.onClick(event);
            }
        }, _this.isSameDay = function (other) {
            return (0, _date_utils.isSameDay)(_this.props.day, other);
        }, _this.isDisabled = function () {
            return _this.props.disabled || (0, _date_utils.isDayDisabled)(_this.props.day, _this.props);
        }, _this.isInRange = function () {
            var _this$props = _this.props,
                day = _this$props.day,
                startDate = _this$props.startDate,
                endDate = _this$props.endDate;

            if (!startDate || !endDate) return false;

            var before = startDate.clone().startOf('day').subtract(1, 'seconds');
            var after = endDate.clone().startOf('day').add(1, 'seconds');
            return day.clone().startOf('day').isBetween(before, after);
        }, _this.isWeekend = function () {
            var weekday = _this.props.day.day();
            return weekday === 0 || weekday === 6;
        }, _this.isOutsideMonth = function () {
            return typeof _this.props.month !== 'undefined' && _this.props.month !== _this.props.day.month();
        }, _this.getClassNames = function () {
            var _classnames;

            return (0, _classnames3.default)('wix-dropdown-datepicker__day', (_classnames = {}, _classnames[_constants.CLASSES.DATE_PICKER_DAY] = true, _classnames[_constants.CLASSES.DATE_PICKER_DAY_DISABLED] = _this.isDisabled(), _classnames[_constants.CLASSES.DATE_PICKER_DAY_SELECTED] = _this.isSelected(), _classnames[_constants.CLASSES.DATE_PICKER_DAY_HOVERED] = _this._isHovered(), _classnames['wix-dropdown-datepicker__day--disabled'] = _this.isDisabled(), _classnames['wix-dropdown-datepicker__day--selected'] = _this.isSelected(), _classnames['wix-dropdown-datepicker__day--in-range'] = _this.isInRange(), _classnames['wix-dropdown-datepicker__day--today'] = _this.isSameDay((0, _moment2.default)()), _classnames['wix-dropdown-datepicker__day--weekend'] = _this.isWeekend(), _classnames['wix-dropdown-datepicker__day--outside-month'] = _this.isOutsideMonth(), _classnames['wix-dropdown-datepicker__day--no-click'] = !_this._isApplicable(), _classnames));
        }, _this._isHovered = function () {
            var isHovered = false;

            if (_this.props.hovered) {
                isHovered = _this.isSameDay(_this.props.hovered);
            }

            return isHovered;
        }, _this.isSelected = function () {
            return _this.isSameDay(_this.props.selected) && _this.props.selected.month() === _this.props.month;
        }, _this.setMarkerPos = function (markerDim) {
            var el = _this.txt;

            var rx = el.offsetLeft + (0, _jquery2.default)(el).width() / 2,
                ry = el.offsetTop + (0, _jquery2.default)(el).height() / 2;

            var markerPos = {
                left: Math.floor(rx - markerDim.width / 2),
                top: Math.floor(ry - markerDim.height / 2)
            };

            _this.setState({ markerPos: markerPos });
        }, _this.renderMarker = function () {
            var marker = _react2.default.createElement('circle', { cx: '32', cy: '32', r: '30', strokeWidth: '1', fill: 'none' });

            return _react2.default.createElement(
                'div',
                { className: 'wix-dropdown-datepicker__day--selected-marker ' + _constants.CLASSES.DATE_PICKER_MARKER,
                    style: _this.state.markerPos },
                _react2.default.createElement(
                    'svg',
                    { viewBox: '0 0 100 100' },
                    marker
                )
            );
        }, _this._onMouseEnter = function () {
            if (!_this.isDisabled() && !_this.isOutsideMonth()) {
                _this.props.setHover(_this.props.day);
            }
        }, _this._onMouseLeave = function () {
            if (!_this.isDisabled() && !_this.isOutsideMonth()) {
                _this.props.setHover(null);
            }
        }, _this._isApplicable = function () {
            return !_this.props.onlyMonthDays || _this.props.day.month() === _this.props.month;
        }, _this._getLabel = function () {
            var _this$props2 = _this.props,
                day = _this$props2.day,
                locale = _this$props2.locale,
                timezone = _this$props2.timezone;

            return _moment2.default.tz(day, timezone).locale(locale).format('MMMM Do YYYY');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Day.prototype.render = function render() {
        var _this2 = this;

        var date = this._isApplicable() ? this.props.day.date() : null;

        return _react2.default.createElement(
            'div',
            { role: 'gridcell', 'aria-selected': this._isHovered(), ref: function ref(el) {
                    return _this2.wrapper = el;
                }, className: this.getClassNames(), onClick: this.handleClick,
                id: 'site-react-dropdown_' + _Time2.default.serializeDate(this.props.day),
                onMouseEnter: this._onMouseEnter, 'aria-label': this._getLabel() },
            _react2.default.createElement(
                'span',
                { ref: function ref(el) {
                        return _this2.txt = el;
                    },
                    className: 'wix-dropdown-datepicker__day-text', 'aria-hidden': 'true' },
                date
            ),
            this.renderMarker()
        );
    };

    return Day;
}(_react2.default.Component);

Day.displayName = 'Day';


module.exports = Day;